import Attendance from "./components/Attendance";

export default Attendance;
